import React, {useEffect, useState} from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { apiCallBegan } from '../store/api'
import { FaRegCalendarAlt } from '@react-icons/all-files/fa/FaRegCalendarAlt'
import { FaAsterisk } from '@react-icons/all-files/fa/FaAsterisk'
import { AiFillBank } from '@react-icons/all-files/ai/AiFillBank'
import { FaBuilding } from '@react-icons/all-files/fa/FaBuilding'
import { MdLocationOn } from '@react-icons/all-files/md/MdLocationOn'
import { FaRegBuilding } from '@react-icons/all-files/fa/FaRegBuilding'
import Button from './Button';
import Clickable from './Clickable';
import StateSelect from './StateSelect';
import { helper } from '../utilities/helper';
import { showAlert } from '../store/slices/ui';
import { refreshURL } from '../store/slices/cache'
const SignBanking = ({potential, setStep}) => {
    let dispatch = useDispatch()
    let {handleSubmit, register, setValue, errors} = useForm()
    let [selected, setSelected] = useState()
    let [addLoc, setAddLoc] = useState(0)
    let [er, setErr] = useState(0)


    useEffect(() => {
        if(potential?.banking) {
            setValue('account_number', potential?.banking?.account_number)
            setValue('bank', potential?.banking?.bank)
            setValue('routing_number', potential?.banking?.routing_number)
            setValue('name_on_account', potential?.banking?.name_on_account)
            setValue('account_type', potential?.banking?.account_type)
            setValue('billing_address.street', potential?.banking?.billing_address?.street)
            setValue('billing_address.city', potential?.banking?.billing_address?.city)
            setValue('billing_address.state', potential?.banking?.billing_address?.state)
            setValue('billing_address.zip', potential?.banking?.billing_address?.zip)
        } else {
            setValue('billing_address.state', "FL")
        }

    }, [potential])




    let submit = data => {
        if(potential?._id) {
            dispatch(apiCallBegan({method: 'PUT', url: `/user/edits/vendor/${potential?.main_contact?.user?._id || potential?.main_contact?.user}`,showSpinner: true, data: {address: data.billing_address, company_name: potential?.name}, onSuccessFunc: _user =>             apiCallBegan({ url: `/business/edits/${potential?._id}`, method: 'PUT', data: {banking: data, vendor_id: _user.vendor_id} ,  onExtFunc: () => {

                if(setStep) {
                 dispatch(refreshURL(`/business/withContacts/${potential?._id}`))
                 setStep(4)
                } else {
                 dispatch(refreshURL(`/business/portal/${potential?._id}`))
                }
             }})}))

        }

    }

    let addressRow = (num) =>       <div className='row addressRow'>
    <div className={`inputIcon street`}>
            <input  id={`street`}  name={`billing_address.street`}   placeholder={`Billing Street ${num >0 ? `(${num+1})` : ''}`} ref={register({required: 'Please input your billing street'})} />
            <label id={`street`} htmlFor={`street`} ><MdLocationOn /></label>


        </div>
    <div className={`inputIcon city`}>
            <input id={`city`} name={`billing_address.city`}  placeholder='City' ref={register({required: 'Please input billing city'})} />
            <label id={`city`} htmlFor={`city`}></label>


        </div>
    <div className={`inputIcon state`}>
            <select   id={`state`}   name={`billing_address.state`}  ref={register({required: 'Please input your billing state'})} >
            <StateSelect justOptions />
                </select>
            <label id={`state`} htmlFor={`state`}></label>


        </div>
    <div className={`inputIcon zip`}>
            <input id={`zip`}  name={`billing_address.zip`}  placeholder='zip' ref={register({required: 'Please input your billing zip'})} />
            <label  id={`zip`} htmlFor={`zip`} ></label>


        </div>



        </div>

    return <form className="signCont" onSubmit={handleSubmit(submit)}>
        <div className="row">

                <div className={`inputIcon`}>
                    <input  id="account_number" name="account_number"  placeholder='Account Number' ref={register} />
                    <label id="account_number" htmlFor='name' ><AiFillBank /></label>

                            {errors.account_number && <strong className='colorText red' >{errors.account_number?.message}</strong>}
                </div>


                <div className={`inputIcon`}>
                    <input  id="routing_number" name="routing_number"  placeholder='Routing Number'  ref={register}  />
                    <label id="routing_number" htmlFor='routing_number' ></label>

                            {errors.routing_number && <strong className='colorText red' >{errors.routing_number?.message}</strong>}
                </div>


        </div>
        <div className="row">

                <div className={`inputIcon`}>
                    <input  id="bank" name="bank"  placeholder='Bank Name' ref={register} />
                    <label id="bank" htmlFor='bank' ></label>

                            {errors.bank && <strong className='colorText red' >{errors.bank?.message}</strong>}
                </div>


                <div className={`inputIcon`}>
                    <input  id="name_on_account" name='name_on_account' placeholder='Name on bank account'  ref={register}  />
                    <label id="name_on_account" htmlFor='name_on_account' ></label>

                            {errors.name_on_account && <strong className='colorText red' >{errors.name_on_account?.message}</strong>}
                </div>
                <div className={`inputIcon`}>
                    <select  id="account_type" name='account_type' placeholder='Type of Account'  ref={register}  >
                        <option value={null} >Select Account Type</option>
                        <option value={'22'} >Checking Account</option>
                        <option value={'32'} >Savings Account</option>
                        </select>
                    <label id="account_type" htmlFor='account_type' ></label>


                </div>


        </div>

         <>
            {addressRow(0)}


                </>

        <div className='buttons'>
            <Button onClick={()=> setErr(e=> e+1)} className='btn-4  highLight'>{setStep ? 'Continue': 'Submit'}</Button>
        </div>
    </form>
}

export default SignBanking
